import { statusKind, translateStatus } from '@/utils/status';
import css from './StatusPill.module.css';

export function StatusPill({ status }) {
  return <span class={`${css.pill} ${css[statusKind(status)]}`}>{translateStatus(status)}</span>;
}
